import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { useLiberisContext } from '@repo/app-contexts/liberis';

import { EditableRow } from '../common/components/editable-row';
import { PostalAddressForm } from '../common/components/postal-address-form';

export function RepresentativeData() {
  const { t } = useTranslation();
  const { activeBeneficientIndex } = useLiberisContext();
  const beneficientFields = [
    {
      label: t('welcomePage.loanApplicationPossible.liberis.beneficientData.form.phoneNumber'),
      fieldName: `person[${activeBeneficientIndex}].phone`,
      fieldType: 'text',
    },
    {
      label: t('welcomePage.loanApplicationPossible.liberis.beneficientData.form.email'),
      fieldName: `person[${activeBeneficientIndex}].email`,
      fieldType: 'text',
    },
  ];

  return (
    <Box>
      {beneficientFields.map((field, index) => (
        <EditableRow {...field} index={index} key={field.fieldName} />
      ))}
      <PostalAddressForm
        fieldsName={{
          postCode: `person[${activeBeneficientIndex}].address.postCode`,
          city: `person[${activeBeneficientIndex}].address.city`,
          street: `person[${activeBeneficientIndex}].address.street`,
          country: `person[${activeBeneficientIndex}].address.country`,
        }}
      />
    </Box>
  );
}
